<template>
  <!-- <div class="smallRoutine">
    <div class="activityBox">
        <div class="head">
          <span>招商信诺</span>
        </div>
        <div class="smallRoutine_title">{{ shareInfo.shareTitle }}</div>
        <div class="smallRoutine_img">
          <img :src="shareInfo.shareIcon" alt />
        </div>
        <div class="footer">
          <span><i class="el-icon-link"></i></span>
          <span>小程序</span>         
        </div>
      </div>
  </div> -->
  <img
    width="100%"
    :src="shareInfo.shareIcon"
    alt
  />
</template>

<script>
export default {
  // 组件名称
  name: '',
  // 局部注册的组件
  components: {},
  // 组件参数 接收来自父组件的数据
  props: {
    shareInfo: Object
  },
  // 组件状态值
  data () {
    return {

    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，el属性还不存在
  */
  created () {},
  /**
  * el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.el 也在文档内。
  */
  mounted () {},
  // 组件方法
  methods: {}
}
</script>

<style scoped>
/* .smallRoutine {
  position: relative;
}
.activityBox {
  position: absolute;
  top:30px;
  left:20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  width:300px;
  height:320px;
  background-color: #fff;
}
.head {
  height:40px;
  line-height: 40px;
  margin-left:20px;
}
.head span {
  font-size: 20px;
  color:#999;
}
.smallRoutine_title {
  margin-left:20px;
  margin-right:20px;
  font-size: 18px;
  color:rgba(52, 56, 54);
  height:40px;
  line-height: 40px;
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.smallRoutine_img {
  margin-left:45px;
}
.footer {
  position: absolute;
  bottom:5px;
  left:20px;
  height:30px;
  line-height: 30px;
}
.footer span i {
  font-size: 18px;
  color:rgba(146, 160, 226);
}
.footer span {
  font-size: 16px;
  color:#999;
  margin-right:5px;
} */
</style>
